import { Button, Flex, List, Modal, Radio, Space, Typography } from 'antd';
import { Volume2 } from 'lucide-react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { soundOptions } from '../../constants';
import { setNotificationSound } from '../../redux/slices/preferenceSlice';
import { store } from '../../redux/store';
import { playNotifySound } from '../../utils';
import { addUserSettings } from '../../redux/actions/users';
import { find } from 'lodash';

const NotificationSound = () => {
    const { notification } = useSelector(state => state.preferenceSlice)
    const [selectedSound, setSelectedSound] = useState(notification || 'default');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const notificationTone = find(soundOptions, { value: notification });

    const handleChange = (e) => {
        setSelectedSound(e.target.value);
        playNotifySound(1, e.target.value)
    };

    const handleOk = () => {
        store.dispatch(setNotificationSound(selectedSound));
        const body = JSON.stringify({
            notification: selectedSound
        })
        addUserSettings({ settings: body })
        setIsModalOpen(false);
    };

    return (
        <div className="notification-Settings mt-6">
            <Flex
                justify="space-between"
                align="center"
                wrap
                gap={16}
            >
                <Space align="center" size="middle">
                    <Volume2 size={20} strokeWidth={1.8} />
                    <div>
                        <Typography.Text type="secondary" style={{ fontSize: 14 }}>
                            Current Tone
                        </Typography.Text>
                        <br />
                        <Typography.Text strong style={{ color: 'var(--primary-color)', fontSize: 16 }}>
                            {notificationTone?.label || 'Default'}
                        </Typography.Text>
                    </div>
                </Space>

                <Button
                    variant="filled"
                    color="default"
                    onClick={() => setIsModalOpen(true)}
                >
                    Change Tone
                </Button>
            </Flex>


            <Modal
                title="Notification Sound"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={() => setIsModalOpen(false)}
                okText="Save"
            >
                <Radio.Group onChange={handleChange} value={selectedSound} style={{ width: '100%' }}>
                    <List
                        dataSource={soundOptions}
                        className='notification-sound'
                        renderItem={(sound) => (
                            <List.Item>
                                <Radio value={sound.value}>
                                    <Space direction="vertical" size={0}>
                                        <Typography.Text strong>{sound.label}</Typography.Text>
                                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                            {sound.description}
                                        </Typography.Text>
                                    </Space>
                                </Radio>
                            </List.Item>
                        )}
                    />
                </Radio.Group>
            </Modal>
        </div>
    );
};

export default NotificationSound;
